module.exports = __webpack_public_path__ + "img/ht_icon_store_3_line.db44d694.svg";